export default __webpack_public_path__ + "static/logo-ey-parthenon-ec9fdee453b66f0e19cb9c8ece99cad1.png";